<template>
    <div>
        <div class="container">
            <h2>Description</h2>
            The application is used in the VPP preparation team to support Business Operators to perform the meter cabinet check.
            Please read the process documentation at xxx and select a Meter Installation ID from the Jira task board or directly
            from Salesforce.
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeView",
    props: {
        msg: String,
        loginState: Boolean
    },
    data() {
        return {};
    },
    computed: {
        isLoggedIn() {
            // `this` points to the component instance
            return this.$store.state.user.loggedIn || this.$session.exists();
        },
        user() {
            // `this` points to the component instance
            return this.$store.state.user.user;
        }
    },
    mounted() {
        console.log("mounting home", this.$session.id());
        console.log("mounting home", this.$store.state.user);
    },
    methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
